import req from "@/request.js";
import { Message } from 'element-ui';

const bpmModel = req.getContext().bpmModel;
const bpmRunTime = req.getContext().bpmRunTime;
export default {
    getMyOftenFlow(cb) {
        req.get(bpmRunTime + `/runtime/instance/v1/getMyOftenFlow`).then(rep => {
            cb(rep.data);
        }).catch(error => {
            error.message && Message.error({ message: error.message, type: 'error' });
        });
    },
    getHasAuthFlowList(queryFilter, cb) {
        req.post(bpmRunTime + `/runtime/instance/v1/getHasAuthFlowList`, queryFilter).then(rep => {
            cb(rep.data)
        }).catch(error => {
            error.message && Message.error({ message: error.message, type: 'error' });
        });
    }
    ,
    saveOftenFlow(data, cb) {
        req.post(bpmModel + `/bpmModel/BpmOftenFlow/v1/saveMyOftenFlow`, data).then(rep => {
            cb(rep.data)
        }).catch(error => {
            error.message && Message.error({ message: error.message, type: 'error' });
        });
    },
    relatedProcess(data,cb) {
        req.post(bpmRunTime+`/runtime/instance/v1/relatedProcess`,data).then(response=>{
            cb(response);
        });
    },
    flowHasStartRights(defKey,cb){
        req.get(bpmModel + `/flow/def/v1/flowHasStartRights?defKey=${defKey}`).then(response => {
            cb(response);
        }, error => {
            error.message && Message.error({ message: error.message, type: 'error' });
        });
    },
    getMainByDefKey(key) {
        return req.get(`${bpmModel}/flow/def/v1/getJson?defKey=${key}`);
    },
    getMainById(id){
        return req.get(`${bpmModel}/flow/def/v1/getMainById?id=${id}`);
    }
}